import { loadData, saveData } from "../../Utils/localStorage";
import { ACTIVE_TAB } from "./Tab.actionType";

const initState = {
  active: loadData("active_Tab") ? loadData("active_Tab") : 2,
};

export const Active_Reducer = (state = initState, { type, payload }) => {
  switch (type) {
    case ACTIVE_TAB:
      saveData("active_Tab", payload);
      return {
        ...state,
        active: payload,
      };

    default:
      return state;
  }
};
